'use client';

import { useState, useCallback } from 'react';
import type { BriefingModalContent } from '@/lib/types';

/**
 * State management hook for CIN-style briefing modals.
 * No route change — modal opens/closes as overlay.
 */
export function useBriefingModal() {
  const [isOpen, setIsOpen] = useState(false);
  const [content, setContent] = useState<BriefingModalContent | null>(null);

  const openBrief = useCallback((brief: BriefingModalContent) => {
    setContent(brief);
    setIsOpen(true);
  }, []);

  const closeBrief = useCallback(() => {
    setIsOpen(false);
    // Delay clearing content so close animation finishes
    setTimeout(() => setContent(null), 200);
  }, []);

  return { isOpen, content, openBrief, closeBrief };
}
